import React, { useContext, useEffect, useState } from 'react';
import { DndProvider } from 'react-dnd';

import { Heading } from '@/components/Elements/Heading';
import './index.scss';
import { ReactComponent as PreviewIcon } from '@/assets/img/preview-icon.svg';
import { ReactComponent as EditIconForm } from '@/assets/img/Edit-icon-intake.svg';
import { ReactComponent as CopyIconStyle } from '@/assets/img/new-copy-style.svg';
import { ReactComponent as LinkCopy } from '@/assets/img/link-copy-sucess.svg';
import { ReactComponent as NoRecordsIcon } from '@/assets/img/no-records-added.svg';
import { ReactComponent as RightArrow } from '@/assets/img/right-graphic-arrow.svg';
import { ReactComponent as RightArrowMobile } from '@/assets/img/right-graphic-arrow-mobile.svg';
import { ReactComponent as Delete } from '@/assets/img/delete-icon-v2.svg';
import { ReactComponent as Edit } from '@/assets/img/edit-icon-new-v2.svg';

import { ReactComponent as SearchIcon } from '@/assets/img/search-iocn-v2.svg';
import { ReactComponent as EditIconRed } from '@/assets/img/edit-icon-new-v2-red.svg';

import { ReactComponent as AddIcon } from '@/assets/img/add-icon-red.svg';

import FieldCard from '../components/FieldCard';
import FormFieldDialog from '../components/FormFieldDialog';
import { FormField, FormFieldGroup, SaveFormField } from '../types';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Container } from '../components/DnDContainer';
import { Tabs } from '@/components/Elements/Tab/Tab';
import { Button } from '@/components/Elements';
import { Modal } from 'react-bootstrap';
import { UserContext } from '@/routes';
import {
  SaveFormFieldData,
  useGetBasicFields,
  useGetPetFields,
  useGetMyIntakeForm,
  useSaveFormFields,
  useDeleteMyIntakeForm,
  useDeleteFormFields,
} from '../api/getFields';
import FormHeadingDialog from '../components/FormHeadingDialog';
import { useRefValue } from '@/features/services/api/getServices';
import { HOST_URL } from '@/config';
import { useAuth } from '@/lib/auth';
import { link } from 'fs';
import { showNotification } from '@/utils/notificationUtils';
import ConfirmationDialogV2 from '@/components/Elements/ConfirmationDialog/ConfirmationDialogV2';
import { useNavigate } from 'react-router-dom';

export const CreateIntakeForm = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const userContext = useContext(UserContext);
  const ownerFieldsMutation = useGetBasicFields();
  const petFieldsMutation = useGetPetFields();
  const saveFormFieldMutation = useSaveFormFields();
  const deleteFormFieldMutation = useDeleteFormFields();
  const getIntakeFormMutation = useGetMyIntakeForm();
  const deleteIntakeFormMutation = useDeleteMyIntakeForm();
  const useRefEvents = useRefValue();

  const fieldTabs = [
    {
      label: 'Pet Fields',
      show: true,
      icon: '',
    },
    {
      label: 'Owner Fields',
      show: true,
      icon: '',
    },
  ];
  const [addCustomFields, setAddCustomFields] = useState<boolean>(false);
  const [editFormfield, setEditFormfield] = useState<FormField>();
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [selectedFormFieldGroup, setSelectedFormFieldGroup] = useState<FormFieldGroup[]>([]);
  const [showFormElements, setShowFormElements] = useState<boolean>(false);
  const [ownerBasicFields, setOwnerBasicFields] = useState<FormField[]>([]);
  const [ownerCustomFields, setOwnerCustomFields] = useState<FormField[]>([]);
  const [formHeading, setFormHeading] = useState<string>(
    `${user?.activeLocation?.name} Intake Form`
  );
  const [formDescription, setFormDescription] = useState<string>('');
  const [editFormHeading, setEditFormHeading] = useState<boolean>();
  const [showClearFormConfirmDialog, setShowClearFormConfirmDialog] = useState<boolean>(false);
  const [linkCopied, setLinkCopied] = useState<boolean>(false);

  const [petBasicFields, setPetBasicFields] = useState<FormField[]>([]);
  const [petCustomFields, setPetCustomFields] = useState<FormField[]>([]);
  const [previewForm, setPreviewForm] = useState<boolean>(false);
  const [showNoTermLinkDialog, setShowNoTermLinkDialog] = useState<boolean>(false);
  const [formUrl, setFormUrl] = useState<string>();
  const [searchKey, setSearchKey] = useState('');
  const onFormDialogClose = (data?: FormField) => {
    setAddCustomFields(false);
    setEditFormfield(undefined);
    // if (!userContext?.isLandscape) {
    //   setShowFormElements(true);
    // }
    if (data) {
      getFields();
      updateSavedForm(data);
    }
  };

  useEffect(() => {
    getFields();
    getIntakeForms();
    getRefValues();
  }, []);

  const getFields = async () => {
    const ownerFieldsRes = await ownerFieldsMutation.mutateAsync(undefined);
    const petFieldsRes = await petFieldsMutation.mutateAsync(undefined);

    setOwnerBasicFields(ownerFieldsRes.basic);
    setOwnerCustomFields(ownerFieldsRes.custom);
    setPetBasicFields(petFieldsRes.basic);
    setPetCustomFields(petFieldsRes.custom);
  };

  const getIntakeForms = async () => {
    const intakeFormRes: SaveFormFieldData = (await getIntakeFormMutation.mutateAsync({
      slug: undefined,
    })) as SaveFormFieldData;
    const formFieldGroups: FormFieldGroup[] = [];
    if (intakeFormRes) {
      const ownerFields = getFormFieldsSortedByIndex('owner', intakeFormRes.fields as FormField[]);
      setFormHeading(
        intakeFormRes?.formTitle
          ? intakeFormRes?.formTitle
          : `${user?.activeLocation?.name} Intake Form`
      );
      setFormDescription(intakeFormRes.formDescription);
      ownerFields.length &&
        formFieldGroups.push({
          formFields: ownerFields,
          key: 'owner',
          name: 'Owner Details',
        });

      const petFields = getFormFieldsSortedByIndex('pet', intakeFormRes.fields as FormField[]);
      petFields.length &&
        formFieldGroups.push({
          formFields: petFields,
          key: 'pet',
          name: 'Pet Details',
        });
      setSelectedFormFieldGroup(formFieldGroups);
      if (ownerFields.length || petFields.length) {
        setFormUrl(HOST_URL + `business/${user?.businessSlug}/userform`);
      }
    }
  };

  const getRefValues = async () => {
    const res = await useRefEvents.mutateAsync({
      businessId: 1,
    });
    const breedList =
      res &&
      res.breed_list.map((item: any) => ({
        label: item,
        value: item,
        isSelected: false,
      }));
    const colorList =
      res &&
      res.pet_color_list.map((item: any) => ({
        label: item,
        value: item,
        isSelected: false,
      }));
    userContext?.setReferenceValues({
      breeds: breedList,
      colors: colorList,
    });
  };
  const updateSavedForm = (data: FormField) => {
    const filteredFieldGroup = selectedFormFieldGroup.find((sfg) => sfg.key === data.category);
    if (filteredFieldGroup) {
      const formFields = filteredFieldGroup.formFields;
      if (formFields && formFields.length) {
        const filteredIndex = formFields.findIndex((ff) => ff.fieldName === data?.fieldName);
        if (filteredIndex >= 0) {
          formFields.splice(filteredIndex, 1, data);
          filteredFieldGroup.formFields = [...formFields];
          setSelectedFormFieldGroup([...selectedFormFieldGroup]);
        }
      }
    }
  };
  const getFormFieldsSortedByIndex = (type: 'owner' | 'pet', formFields: FormField[]) => {
    const filteredFormFields = formFields.filter((ff) => ff.category === type);
    filteredFormFields.sort((a, b) => {
      return a.orderIndex - b.orderIndex;
    });
    return filteredFormFields;
  };

  const onTabIndexChange = (index: number) => {
    setSearchKey('');
    setSelectedTabIndex(index);
  };

  const onFormFieldSelect = (formField: FormField) => {
    const filteredFieldGroup = selectedFormFieldGroup.find(
      (sfg) => sfg.key === (selectedTabIndex === 1 ? 'owner' : 'pet')
    );
    if (filteredFieldGroup) {
      const formFields = filteredFieldGroup.formFields;
      if (formFields && formFields.length) {
        const filteredIndex = formFields.findIndex((ff) => ff.fieldName === formField.fieldName);
        if (filteredIndex >= 0) {
          formFields.splice(filteredIndex, 1);
        } else {
          formFields.push(formField);
        }
        filteredFieldGroup.formFields = [...formFields];
      } else {
        filteredFieldGroup.formFields = [{ ...formField }];
      }
    } else {
      if (selectedFormFieldGroup.length == 1 && selectedTabIndex === 0) {
        selectedFormFieldGroup.splice(1, 0, {
          name: 'Pet Details',
          key: 'pet',
          formFields: [{ ...formField }],
        });
      } else {
        selectedFormFieldGroup.splice(0, 0, {
          name: selectedTabIndex === 1 ? 'Owner Details' : 'Pet Details',
          key: selectedTabIndex === 1 ? 'owner' : 'pet',
          formFields: [{ ...formField }],
        });
      }
    }

    setSelectedFormFieldGroup([...selectedFormFieldGroup]);
  };
  const isFormFieldSelected = (formField: FormField) => {
    const filteredFieldGroup = selectedFormFieldGroup.find(
      (sfg) => sfg.key === (selectedTabIndex === 1 ? 'owner' : 'pet')
    );
    if (filteredFieldGroup) {
      const formFields = filteredFieldGroup.formFields;
      if (formFields && formFields.length) {
        const filteredIndex = formFields.findIndex((ff) => ff.fieldLabel === formField.fieldLabel);
        if (filteredIndex >= 0) {
          return true;
        }
      }
    }
    return false;
  };
  const onFormFieldsChange = (sffg: FormFieldGroup, formFields: FormField[]) => {
    const filteredFieldGroupIndex = selectedFormFieldGroup.findIndex((ffg) => ffg.key === sffg.key);
    if (formFields.length > 0) {
      sffg.formFields = [...formFields];
      selectedFormFieldGroup.splice(filteredFieldGroupIndex, 1, { ...sffg });
    } else {
      sffg.formFields = [];
      selectedFormFieldGroup.splice(filteredFieldGroupIndex, 1);
    }
    setSelectedFormFieldGroup(selectedFormFieldGroup.length > 0 ? [...selectedFormFieldGroup] : []);
  };
  const addNewFormFields = () => {
    setAddCustomFields(true);
    setShowFormElements(false);
  };
  const onEditFormHeading = () => {
    setEditFormHeading(true);
  };

  const addSelectedFormElements = () => {
    setShowFormElements(false);
  };
  const saveUserForm = async (clear = false) => {
    const ownerFieldValidation = validateRequireField('owner');
    if (ownerFieldValidation) {
      showNotification({
        type: 'error',
        title: ownerFieldValidation,
      });
      return;
    }
    const petFieldValidation = validateRequireField('pet');
    if (petFieldValidation) {
      showNotification({
        type: 'error',
        title: petFieldValidation,
      });
      return;
    }
    const ownerFields = getFormFieldsForSaving('owner');
    const petFields = getFormFieldsForSaving('pet');
    const req: SaveFormFieldData = {
      formTitle: clear ? '' : formHeading,
      formDescription: clear ? '' : formDescription,
      fields: clear ? [] : ownerFields.concat(petFields),
    };
    try {
      const res = await saveFormFieldMutation.mutateAsync(req);
    } catch (e: any) {
      if (e?.response?.data?.errors[0].code === 'ERR202') {
        setShowNoTermLinkDialog(true);
      }
    }
    if (ownerFields.length || petFields.length) {
      setFormUrl(HOST_URL + `business/${user?.businessSlug}/userform`);
    }
  };
  const validateRequireField = (type: 'pet' | 'owner') => {
    let errorMessage = '';
    const filteredFieldGroup = selectedFormFieldGroup.find((sfg) => sfg.key === type);
    const requiredFormFields =
      type === 'owner'
        ? ownerBasicFields.filter((obf) => (obf.isRequired ? true : false))
        : petBasicFields.filter((obf) => (obf.isRequired ? true : false));
    if (filteredFieldGroup && filteredFieldGroup.formFields.length > 0) {
      requiredFormFields.every((orf) => {
        const requiredFormField = filteredFieldGroup?.formFields.find(
          (ff) => ff.fieldName === orf.fieldName
        );
        if (!requiredFormField) {
          errorMessage = `Please add ${orf.fieldLabel} field to save the form`;
          return false;
        }
        return true;
      });
    } else {
      errorMessage = `Please add form fields to save the form`;
    }
    return errorMessage;
  };
  const getFormFieldsForSaving = (type: 'owner' | 'pet') => {
    const filteredFieldGroup = selectedFormFieldGroup.find((sfg) => sfg.key === type);
    const saveFormFields: SaveFormField[] = [];
    if (filteredFieldGroup) {
      const formFields = filteredFieldGroup.formFields;
      formFields.forEach((ff, index) => {
        saveFormFields.push({
          orderIndex: index,
          id: ff.id ? ff.id : '',
        });
      });
    }
    return saveFormFields;
  };
  const cancelForm = () => {
    setShowClearFormConfirmDialog(true);
  };
  const onFormHeadingUpdate = (heading: string, description: string) => {
    setFormHeading(heading);
    setFormDescription(description);
    setEditFormHeading(false);
  };

  const onFormFieldValueChange = (formField: FormField) => {
    const filteredFieldGroup = selectedFormFieldGroup.find((sfg) => sfg.key === formField.category);
    if (filteredFieldGroup) {
      const formFields = filteredFieldGroup.formFields;
      if (formFields && formFields.length) {
        const filteredIndex = formFields.findIndex((ff) => ff.fieldName === formField.fieldName);
        if (filteredIndex >= 0) {
          formFields.splice(filteredIndex, 1, formField);
        }
      }
    }
    setSelectedFormFieldGroup([...selectedFormFieldGroup]);
  };

  const onSearchTextChange = (e: any) => {
    setSearchKey(e.target.value);
  };
  const onDeleteClicked = async (formField: FormField) => {
    if (isFormFieldSelected(formField)) {
      showNotification({
        type: 'error',
        title: `'${formField.fieldLabel}' is added to the intake form and you cannot delete it. Remove from the form and try it`,
      });
      return;
    }
    await deleteFormFieldMutation.mutateAsync({ data: formField });
    getFields();
  };
  const onEditClicked = (formField: FormField) => {
    setEditFormfield(formField);
  };

  const selectedBasicFields = selectedTabIndex === 1 ? ownerBasicFields : petBasicFields;
  const selectedCustomFields = selectedTabIndex === 1 ? ownerCustomFields : petCustomFields;
  let basicFields: FormField[] = [];
  let customFields: FormField[] = [];
  if (searchKey) {
    basicFields = selectedBasicFields.filter(
      (bf) => bf.fieldLabel.toLowerCase().indexOf(searchKey.toLowerCase()) >= 0
    );
    customFields = selectedCustomFields.filter(
      (bf) => bf.fieldLabel.toLowerCase().indexOf(searchKey.toLowerCase()) >= 0
    );
  } else {
    basicFields = selectedBasicFields;
    customFields = selectedCustomFields;
  }
  const renderIntakeFormElements = () => {
    return (
      <div className="form-element-section">
        <div className="top-section">
          <Heading title="Field type" description="Select the fields for your customer form" />
          <div className="search-input-container">
            <input placeholder="Search" onChange={onSearchTextChange} value={searchKey} />
            <SearchIcon />
          </div>
          <Tabs
            key={'appt-view'}
            selectedTabIndex={selectedTabIndex}
            onChange={onTabIndexChange}
            tabs={fieldTabs}
            mode="tab"
            responsive={false}
            isroomBooking={true}
          />
        </div>
        <div className="form-fields">
          <div className="basic-section">
            <label>Basic Fields</label>
          </div>
          <div className="fields basic">
            {basicFields.map((bf, index) => (
              <FieldCard
                data={bf}
                key={`bf-${index}`}
                isSelected={isFormFieldSelected(bf)}
                onSelect={onFormFieldSelect}
                showType={false}
              />
            ))}
          </div>
          <div className="custom-section">
            <label>Custom Fields</label>
            <label className="add" onClick={addNewFormFields}>
              + Add new
            </label>
          </div>
          <div className="fields custom">
            {customFields.map((bf, index) => (
              <FieldCard
                data={bf}
                key={`bf-${index}`}
                isSelected={isFormFieldSelected(bf)}
                onSelect={onFormFieldSelect}
                showType={false}
                options={[
                  {
                    label: 'Edit',
                    icon: Edit,
                    onClickHandler: () => onEditClicked(bf),
                    itemClassName: 'edit',
                  },
                  {
                    label: 'Delete',
                    icon: Delete,
                    onClickHandler: () => onDeleteClicked(bf),
                    itemClassName: 'delete',
                  },
                ]}
              />
            ))}
          </div>
        </div>
      </div>
    );
  };
  const onFormFieldEdit = (formField: FormField, index: number) => {
    setEditFormfield(formField);
  };
  const onPreview = () => {
    if (formUrl) {
      setPreviewForm(!previewForm);
    }
  };
  const onLinkCopyClicked = () => {
    if (formUrl) {
      navigator.clipboard.writeText(formUrl);
      setLinkCopied(true);
      showNotification({
        type: 'success',
        title: 'Link copied successfully!',
      });
      setTimeout(() => {
        setLinkCopied(false);
      }, 1000);
    }
  };
  const onCancelClearFormDialog = () => {
    setShowClearFormConfirmDialog(false);
  };
  const onConfirmClearFormDialog = async () => {
    setShowClearFormConfirmDialog(false);
    await deleteIntakeFormMutation.mutateAsync({});
    setSelectedFormFieldGroup([]);
    setFormUrl(undefined);
    setFormHeading(`${user?.activeLocation?.name} Intake Form`);
    setFormDescription('');
  };
  const onConfirmTerms = () => {
    navigate('/settings?target=terms-of-service');
  };
  return (
    <>
      <section className="intake-form-section">
        <div className={`intake-form-creation ${previewForm ? 'preview' : ''}`}>
          {(userContext?.isLandscape ||
            (!userContext?.isLandscape && !(addCustomFields || editFormfield))) && (
            <div className="top-section">
              <span className="holder-top">
                {!previewForm && (
                  <Heading
                    title={formHeading}
                    description={formDescription}
                    isEditable={true}
                    onEdit={onEditFormHeading}
                    defaultDesc={`${user?.activeLocation?.name} Intake Form Description`}
                  />
                )}
              </span>
              <div className="right-link-section">
                <>
                  {previewForm ? (
                    userContext?.isLandscape ? (
                      <Button
                        startIcon={<EditIconRed />}
                        variant="inverse"
                        size="lg"
                        onClick={onPreview}
                      >
                        Edit Form
                      </Button>
                    ) : (
                      <EditIconForm className="cursor-pointer" onClick={onPreview} />
                    )
                  ) : (
                    <span className="preview-icon" onClick={onPreview}>
                      <PreviewIcon />
                    </span>
                  )}
                  <div className="link-section">
                    <input
                      className={`set-max-width ${formUrl ? '' : 'disabled-field'}`}
                      value={formUrl ? formUrl : HOST_URL + `business/${user?.businessSlug}`}
                      disabled
                    />
                    <span
                      className={`link-copy ${formUrl ? '' : 'disabled'} ${
                        linkCopied ? 'copied' : ''
                      }`}
                      title={formUrl ? '' : 'Please add form fields and save it to copy the link'}
                    >
                      {linkCopied ? (
                        <LinkCopy onClick={onLinkCopyClicked} />
                      ) : (
                        <CopyIconStyle className="copy-icon" onClick={onLinkCopyClicked} />
                      )}
                    </span>
                  </div>
                </>
              </div>
            </div>
          )}
          <DndProvider backend={HTML5Backend}>
            {(userContext?.isLandscape ||
              (!userContext?.isLandscape && !(addCustomFields || editFormfield))) && (
              <div
                id="petsked-form-section"
                className={`bottom-form-section ${
                  selectedFormFieldGroup.length === 0 ? 'no-element' : ''
                }`}
              >
                {!showFormElements &&
                selectedFormFieldGroup &&
                selectedFormFieldGroup.length > 0 ? (
                  <>
                    {previewForm && (
                      <div className="form-group">
                        <div className="form-title">
                          <Heading title={formHeading} description={formDescription} />
                        </div>
                      </div>
                    )}
                    {selectedFormFieldGroup.map((sffg, index) =>
                      sffg.formFields.length > 0 ? (
                        <div className="form-group">
                          <div className="form-group-heading">
                            <h6>{sffg.name}</h6>
                          </div>
                          <Container
                            formFields={sffg.formFields}
                            onChange={(fFields) => onFormFieldsChange(sffg, fFields)}
                            onEditField={onFormFieldEdit}
                            preview={previewForm}
                            onFieldValueChange={onFormFieldValueChange}
                            disableDrag={previewForm ? true : false}
                            disabled={true}
                          />
                          {selectedFormFieldGroup.length - 1 === index && sffg.key === 'pet' && (
                            <div className="wrapper">
                              <div className="action-pet">
                                <Button
                                  variant="inverse"
                                  className="addIcon"
                                  size="lg"
                                  startIcon={<AddIcon />}
                                >
                                  Add another pet
                                </Button>
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <></>
                      )
                    )}
                    {!userContext?.isLandscape && (
                      <div className="action">
                        <Button
                          className="addIcon"
                          variant="inverse"
                          onClick={() => setShowFormElements(true)}
                          startIcon={<AddIcon />}
                        >
                          Add form fields
                        </Button>
                      </div>
                    )}
                    {!previewForm && (
                      <div className="form-action-submit">
                        <div className="left-section"></div>
                        <div className="right-section">
                          <Button
                            variant="nobg"
                            size="lg"
                            disabled={deleteIntakeFormMutation.isLoading}
                            onClick={cancelForm}
                          >
                            {deleteIntakeFormMutation.isLoading ? 'Deleting...' : 'Delete Form'}
                          </Button>
                          <Button
                            variant="primary"
                            size="lg"
                            disabled={saveFormFieldMutation.isLoading}
                            onClick={() => saveUserForm()}
                          >
                            {saveFormFieldMutation.isLoading ? 'Saving...' : 'Save Form'}
                          </Button>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="icon-holder">
                    <div>
                      <NoRecordsIcon className="no-records" />
                    </div>
                    <p className="no-records-bold">No fields added yet !</p>
                    <p className="no-records-desc">
                      {userContext?.isLandscape
                        ? 'Start creating the form by adding fields from the right.'
                        : 'Start creating the form by adding fields from the below button.'}
                    </p>
                    <div className="action">
                      <Button
                        variant="inverse"
                        onClick={() => setShowFormElements(true)}
                        startIcon={<AddIcon />}
                      >
                        Add form fields
                      </Button>
                    </div>
                    <RightArrow className="right-arrow" />
                    <RightArrowMobile className="right-arrow-mobile" />
                  </div>
                )}
              </div>
            )}
            {(addCustomFields || editFormfield) && (
              <FormFieldDialog
                formFieldCategory={
                  editFormfield ? editFormfield.category : selectedTabIndex == 1 ? 'owner' : 'pet'
                }
                open={true}
                onClose={onFormDialogClose}
                data={editFormfield}
              />
            )}
          </DndProvider>
        </div>

        {!previewForm && <div className="intake-form-elements">{renderIntakeFormElements()}</div>}
        {showFormElements && (
          <Modal
            show={showFormElements}
            onHide={() => setShowFormElements(false)}
            className="petsked-modal-dialog  form-elements-dialog"
          >
            <Modal.Header closeButton>
              <Heading
                size="lg"
                title="Add Fields"
                description="Select the fields for your customer form"
              />
            </Modal.Header>
            <Modal.Body>{renderIntakeFormElements()}</Modal.Body>
            <Modal.Footer>
              <Button variant="primary" size="lg" onClick={addSelectedFormElements}>
                Add Selected fields
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </section>
      {editFormHeading && (
        <FormHeadingDialog
          show={editFormHeading}
          heading={formHeading}
          description={formDescription}
          onClose={() => setEditFormHeading(false)}
          onUpdate={onFormHeadingUpdate}
        />
      )}
      {showClearFormConfirmDialog && (
        <ConfirmationDialogV2
          title={'Clear Form'}
          description={'Do you really want to clear the form fields? '}
          yesButtonLabel="Yes, Confirm"
          noButtonLabel="No, Not Now"
          onCancel={onCancelClearFormDialog}
          onConfirm={onConfirmClearFormDialog}
          open={showClearFormConfirmDialog}
        ></ConfirmationDialogV2>
      )}
      {showNoTermLinkDialog && (
        <ConfirmationDialogV2
          title={'Missing terms of service document !'}
          description={
            'Terms of Service document missing. Please upload it from the settings page or remove it from this form.'
          }
          yesButtonLabel="Yes, Go to settings page"
          noButtonLabel="No, Not Now"
          onCancel={() => setShowNoTermLinkDialog(false)}
          onConfirm={onConfirmTerms}
          open={showNoTermLinkDialog}
        ></ConfirmationDialogV2>
      )}
    </>
  );
};
